var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920.691,
    height: 828.963,
    viewBox: "0 0 1920.691 828.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_336",
    "data-name": "Grupo 336",
    transform: "translate(-4233.576 -1394.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1154",
    "data-name": "Caminho 1154",
    d: "M4233.9,1405.819c482.008-11.416,849-73.9,1272,310.1,411.127,373.222,648,466.305,648,466.305",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1155",
    "data-name": "Caminho 1155",
    d: "M4233.9,1424.828c476.82-16.15,845.023-80.776,1270,296.294,409,365.8,650,445.989,650,445.989",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1156",
    "data-name": "Caminho 1156",
    d: "M4233.9,1443.838c471.633-20.885,842.507-89.333,1268,282.484C5910.173,2083.1,6153.9,2152,6153.9,2152",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1157",
    "data-name": "Caminho 1157",
    d: "M4233.9,1462.847c466.445-25.619,839.206-97.042,1266,268.676,406.793,348.579,654,405.355,654,405.355",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1158",
    "data-name": "Caminho 1158",
    d: "M4233.9,1481.857c461.257-30.354,835.869-104.744,1264,254.866,405.266,340.4,656,385.039,656,385.039",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1159",
    "data-name": "Caminho 1159",
    d: "M4233.9,1500.866c456.07-35.088,832.493-112.436,1262,241.057,403.7,332.251,658,364.723,658,364.723",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1160",
    "data-name": "Caminho 1160",
    d: "M4233.9,1519.876c450.882-39.823,829.08-120.117,1260,227.247,402.086,324.122,660,344.406,660,344.406",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1161",
    "data-name": "Caminho 1161",
    d: "M4233.9,1538.885c445.694-44.557,825.627-127.785,1258,213.438,400.433,316.018,662,324.09,662,324.09",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1162",
    "data-name": "Caminho 1162",
    d: "M4233.9,1557.9c440.507-49.292,822.135-135.438,1256,199.628,398.738,307.939,664,303.774,664,303.774",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1163",
    "data-name": "Caminho 1163",
    d: "M4233.9,1576.9c435.319-54.026,818.6-143.074,1254,185.82,397,299.888,666,283.457,666,283.457",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1164",
    "data-name": "Caminho 1164",
    d: "M4233.9,1595.914c430.131-58.761,815.03-150.691,1252,172.01,395.218,291.868,668,263.14,668,263.14",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1165",
    "data-name": "Caminho 1165",
    d: "M4233.9,1614.923c424.944-63.495,811.417-158.285,1250,158.2,393.4,283.878,670,242.824,670,242.824",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1166",
    "data-name": "Caminho 1166",
    d: "M4233.9,1633.933c419.756-68.23,807.762-165.856,1248,144.391,391.529,275.922,672,222.508,672,222.508",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1167",
    "data-name": "Caminho 1167",
    d: "M4233.9,1652.942c414.568-72.964,804.066-173.4,1246,130.582,389.621,268,674,202.192,674,202.192",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1168",
    "data-name": "Caminho 1168",
    d: "M4233.9,1671.952c409.38-77.7,800.328-180.916,1244,116.773,387.671,260.113,676,181.874,676,181.874",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1169",
    "data-name": "Caminho 1169",
    d: "M4233.9,1690.961c404.193-82.433,796.548-188.4,1242,102.964,385.68,252.266,678,161.558,678,161.558",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1170",
    "data-name": "Caminho 1170",
    d: "M4233.9,1709.971c399-87.168,792.726-195.846,1240,89.154,383.647,244.458,680,141.242,680,141.242",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1171",
    "data-name": "Caminho 1171",
    d: "M4233.9,1728.98c393.817-91.9,788.862-203.255,1238,75.345,381.575,236.691,682,120.925,682,120.925",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1172",
    "data-name": "Caminho 1172",
    d: "M4233.9,1747.99c388.63-96.637,784.956-210.624,1236,61.535,379.463,228.968,684,100.609,684,100.609",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1173",
    "data-name": "Caminho 1173",
    d: "M4233.9,1767c383.442-101.371,781.009-217.946,1234,47.726,377.314,221.29,686,80.293,686,80.293",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1174",
    "data-name": "Caminho 1174",
    d: "M4233.9,1786.009c378.254-106.107,777.022-225.221,1232,33.917,375.127,213.657,688,59.976,688,59.976",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1175",
    "data-name": "Caminho 1175",
    d: "M4233.9,1805.018c373.067-110.841,772.993-232.443,1230,20.108,372.9,206.074,690,39.659,690,39.659",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1176",
    "data-name": "Caminho 1176",
    d: "M4233.9,1824.028c367.879-115.576,768.925-239.61,1228,6.3,370.646,198.541,692,19.343,692,19.343",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1177",
    "data-name": "Caminho 1177",
    d: "M4233.9,1843.037c362.691-120.31,764.819-246.716,1226-7.511,368.356,191.059,694-.973,694-.973",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1178",
    "data-name": "Caminho 1178",
    d: "M4233.9,1862.047c357.5-125.045,760.675-253.759,1224-21.321,366.034,183.631,696-21.29,696-21.29",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1179",
    "data-name": "Caminho 1179",
    d: "M4233.9,1881.056c352.316-129.779,756.494-260.734,1222-35.129,363.684,176.257,698-41.607,698-41.607",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1180",
    "data-name": "Caminho 1180",
    d: "M4233.9,1900.066c347.128-134.514,752.279-267.637,1220-48.939,361.306,168.94,700-61.923,700-61.923",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1181",
    "data-name": "Caminho 1181",
    d: "M4233.9,1919.075c341.941-139.248,748.031-274.462,1218-62.748,358.9,161.681,702-82.239,702-82.239",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1182",
    "data-name": "Caminho 1182",
    d: "M4233.9,1938.085c336.753-143.983,743.751-281.207,1216-76.558,356.478,154.481,704-102.556,704-102.556",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1183",
    "data-name": "Caminho 1183",
    d: "M4233.9,1957.094c331.565-148.717,739.443-287.866,1214-90.367,354.033,147.341,706-122.872,706-122.872",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1184",
    "data-name": "Caminho 1184",
    d: "M4233.9,1976.1c326.377-153.452,735.108-294.436,1212-104.176,351.571,140.262,708-143.189,708-143.189",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1185",
    "data-name": "Caminho 1185",
    d: "M4233.9,1995.113c321.19-158.186,730.749-300.91,1210-117.985,349.1,133.246,710-163.506,710-163.506",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1186",
    "data-name": "Caminho 1186",
    d: "M4233.9,2014.123c316-162.921,726.37-307.287,1208-131.8,346.608,126.294,712-183.822,712-183.822",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1187",
    "data-name": "Caminho 1187",
    d: "M4233.9,2033.132c310.814-167.655,721.974-313.558,1206-145.6,344.114,119.406,714-204.138,714-204.138",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1188",
    "data-name": "Caminho 1188",
    d: "M4233.9,2052.142c305.627-172.39,717.563-319.723,1204-159.414,341.616,112.583,716-224.454,716-224.454",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1189",
    "data-name": "Caminho 1189",
    d: "M4233.9,2071.151c300.439-177.124,713.143-325.774,1202-173.223,339.117,105.825,718-244.771,718-244.771",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1190",
    "data-name": "Caminho 1190",
    d: "M4233.9,2090.161c295.251-181.859,708.717-331.71,1200-187.032,336.622,99.132,720-265.088,720-265.088",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1191",
    "data-name": "Caminho 1191",
    d: "M4233.9,2109.17c290.064-186.593,704.29-337.525,1198-200.841,334.134,92.505,722-285.4,722-285.4",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1192",
    "data-name": "Caminho 1192",
    d: "M4233.9,2128.18c284.876-191.328,699.867-343.216,1196-214.651,331.658,85.944,724-305.72,724-305.72",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1193",
    "data-name": "Caminho 1193",
    d: "M4233.9,2147.189c279.688-196.062,695.453-348.779,1194-228.46,329.2,79.449,726-326.037,726-326.037",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1194",
    "data-name": "Caminho 1194",
    d: "M4233.9,2166.2c274.5-200.8,691.053-354.212,1192-242.27,326.759,73.018,728-346.353,728-346.353",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1195",
    "data-name": "Caminho 1195",
    d: "M4233.9,2185.208c269.313-205.531,686.674-359.51,1190-256.078,324.344,66.651,730-366.67,730-366.67",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1196",
    "data-name": "Caminho 1196",
    d: "M4233.9,2204.218c264.125-210.266,682.32-364.673,1188-269.888,321.958,60.348,732-386.987,732-386.987",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1197",
    "data-name": "Caminho 1197",
    d: "M4233.9,2223.227c258.937-215,678-369.7,1186-283.7,319.606,54.107,734-407.3,734-407.3",
    fill: "none",
    stroke: "#e4ebf8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.2646a5d3ac804cf24e2be60d9fda47fd.svg";
export { ForwardRef as ReactComponent };